<template>
    <v-dialog
        v-model="show"
        width="500"
        @click:outside="close"
    >
        <v-card v-if="show">
            <v-toolbar
                color="primary"
                dark
                flat
            >
                <v-toolbar-title class="text-capitalize">
                    Transfer Rank
                </v-toolbar-title>
                <v-spacer />
                <v-btn
                    icon
                    color="white"
                    @click="close"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text class="pt-3 pb-6">
                <p>
                    Your rate at {{ order.exchange_rate }} {{ order.poster_currency }} will rank your
                    offer <b>{{ order.rank }}</b> of all offers
                    available on Kaoshi Network for transfers to {{ matcherCountry }}.
                    Increase your rate to rank your offer higher.
                </p>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: {
            show: Boolean,
            order: {
                type: Object,
                default: () => ({}),
            },
        },
        computed: {
            matcherCountry() {
                if (this.order.type === 'hybrid') {
                    return 'Nigeria Domiciliary Account';
                }
                return this.order.matcher_country;
            },
        },
        methods: {
            close() {
                this.$emit('update:show', false);
            },
        },
    };
</script>
